import moment from 'moment';
import { fnComparedValueAndCriterion } from 'utils/logProcessing';

export default function makeDataLevel(d, gasCriterion, pageIndex, pageSize, index) {
  return {
    rnum: pageIndex * pageSize + index + 1,
    areaNo: d.module.areaNo,
    areaNm: d.module.areaNm,
    modelNm: d.module.modelNm,
    h2s: d.h2s,
    co2: d.co2,
    statusCode: d.statusCode,
    status: fnComparedValueAndCriterion(d, d.module.moduleScn, gasCriterion)[0],
    battery: d.battery,
    regDate: moment(d.rgstDt).format('YYYY-MM-DD HH:mm:ss'),
  };
}
